import { useQuery } from "@tanstack/react-query";
import { FirestoreDataConverter, Timestamp, collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { firestore } from "@/base";

export const AVALIACOES_IA_COLLECTION_KEY = ["avaliacoes-ia"] as const;

type TAvaliacaoIADocument = Omit<TAvaliacaoIA, "createdAt" | "updatedAt"> & {
  createdAt: Timestamp;
  updatedAt?: Timestamp;
};

const avaliacaoIAConverter: FirestoreDataConverter<TAvaliacaoIA> = {
  toFirestore(data) {
    delete data.id;
    delete data.refPath;
    return data;
  },
  fromFirestore(snap) {
    const { createdAt, updatedAt, ...document } = snap.data() as TAvaliacaoIADocument;
    const data: TAvaliacaoIA = {
      ...document,
      id: snap.id,
      createdAt: createdAt.toDate(),
      refPath: snap.ref.path
    };

    if (updatedAt) {
      data.updatedAt = updatedAt.toDate();
    }

    return data;
  }
};

/**
 *
 * @param ideiaReferencePath
 */
async function getLatestAvaliacaoIA(ideiaReferencePath: string) {
  const collectionReference = collection(firestore, `${ideiaReferencePath}/avaliacoesIA`).withConverter(
    avaliacaoIAConverter
  );
  const q = query(collectionReference, orderBy("createdAt", "desc"), limit(1));
  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const [document_] = snapshot.docs;
  return document_ ? document_.data() : null;
}

/**
 * Fetch latest AI evaluation for an idea.
 * @param ideia - Ideia
 * @returns Query result
 */
function useGetAvaliacoesIA(ideia?: TIdeia) {
  const referencePath = ideia?.refPath ?? "";

  return useQuery({
    queryKey: [AVALIACOES_IA_COLLECTION_KEY, referencePath],
    queryFn: () => getLatestAvaliacaoIA(referencePath),
    enabled: Boolean(referencePath)
  });
}

export default useGetAvaliacoesIA;
